/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import { faSearch } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import * as wjcCore from "@grapecity/wijmo"
import * as wjcGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"
import * as wjrGridFilter from "@grapecity/wijmo.react.grid.filter"

import React, { useEffect, useState } from "react"
import { Button, Col, Container, Row } from "react-bootstrap"
import CONSTANT from "../../constant"
import VALIDATE_CONSTANT from "../../constant/validateConstant"
import {
  TYosyaListGetReq,
  T傭車マスタ,
} from "../../service/master/yosya/TYosya"
import YosyaService from "../../service/master/yosya/yosyaService"

import { TWijmoCellTemplateContext } from "../../type/wijmoComponents"
import EmptyTextHeader from "../FlexGridWrapper/EmptyTextHeader"
import GridFooter from "../FlexGridWrapper/GridFooter"
import TextInput from "../InputWrapper/TextInput"
import LocalAlertComponent from "../LocalAlertComponent"
import { ModalOuter, TModalTypes } from "../Modal/ModalOuter"
import Spinner from "../Spinner"

/**
 * 傭車検索モーダル
 * @param {*} props
 * @return {*} reactNode
 */
const YosyaSearchModal: React.FC<
  Omit<TModalTypes, "title"> & {
    title?: string
    footer?: React.ReactNode
    yosyaSakiName?: string | null
    yosyaSakiCode?: string | null
    isReadOnly: boolean
    setYosya: (value: T傭車マスタ) => unknown
  }
> = (props) => {
  //#region [state]
  // 検索項目
  const [傭車先コード, set傭車先コード] = useState<string>()
  const [傭車先名, set傭車先名] = useState<string>()

  // Grid
  const [pageSize, setPageSize] = useState<number>(50)

  const [flexGrid, setFlexGrid] = useState<wjcGrid.FlexGrid>()

  // Spinner用
  const [isSpinnerShow, setIsSpinnerShow] = useState(false)

  // アラート用State
  const [AlertSource, setAlertSource] = useState<any>()
  //#endregion

  //#region [method]
  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページサイズ
   * @returns CollectionView
   */

  const createCollectionView = (data: Array<any>, pageSize: number) =>
    new wjcCore.CollectionView(data, {
      pageSize,
    })

  const [gridData, setGridData] = useState<{
    data: wjcCore.CollectionView
  }>({
    data: createCollectionView([], pageSize),
  })
  const gridInitialized = (grid: wjcGrid.FlexGrid) => {
    grid.itemsSource = gridData.data
    setFlexGrid(grid)
  }

  const search = async (searchCondition?: TYosyaListGetReq) => {
    setIsSpinnerShow(true)
    setAlertSource(undefined)
    try {
      const res = await new YosyaService().getList({
        傭車先名: searchCondition?.傭車先名 ?? 傭車先名,
        傭車先コード: searchCondition?.傭車先コード ?? 傭車先コード,
      })

      const newData = createCollectionView([...res.data], pageSize)
      flexGrid!.itemsSource = newData
      setGridData({ data: newData })
      flexGrid!.refresh()
    } catch (error) {
      setAlertSource(error)
    } finally {
      setIsSpinnerShow(false)
    }
  }
  /**
   * 選択ハンドラ
   * @param item
   */
  const submitHandler = (item: T傭車マスタ) => {
    props.setYosya(item)
    props.setIsShow(false)
  }
  //#endregion

  //#region [effect]
  useEffect(() => {
    if (flexGrid == null) return

    if (props.isShow) {
      //表示時
      // 荷主コードが設定されている場合、その荷主コードで検索
      if (
        !wjcCore.isNullOrWhiteSpace(props.yosyaSakiName ?? "") ||
        !wjcCore.isNullOrWhiteSpace(props.yosyaSakiCode ?? "")
      ) {
        set傭車先名(props.yosyaSakiName ?? "")
        set傭車先コード(props.yosyaSakiCode ?? "")
        search({
          傭車先名: props.yosyaSakiName ?? undefined,
          傭車先コード: props.yosyaSakiCode ?? undefined,
        })
      }
    } else {
      // 非表示時中身を空にして閉じる
      set傭車先名("")
      const newData = {
        data: createCollectionView([], pageSize),
      }
      if (flexGrid != null) {
        flexGrid.itemsSource = newData.data
        flexGrid.refresh()
      }
      setGridData(newData)
    }
  }, [props.isShow, flexGrid])

  //#endregion
  return (
    <ModalOuter
      isShow={props.isShow}
      title={props.title ?? "傭車マスタ検索"}
      setIsShow={props.setIsShow}
      size={"xl"}
      footer={props.footer}>
      <Spinner inModal searching={isSpinnerShow}></Spinner>
      <Container fluid>
        {/* アラート表示 */}
        <Row>
          <Col>
            <LocalAlertComponent alertSource={AlertSource} />
          </Col>
        </Row>
        <form>
          <Row>
            <Col>
              <ul className="list-cmn">
                <li className="list-cmn  d-flex">
                  <TextInput
                    style={{ width: "6rem" }}
                    id="傭車先コード"
                    name="傭車先"
                    value={傭車先コード}
                    isReadOnly={props.isReadOnly}
                    setValue={set傭車先コード}
                    maxLength={VALIDATE_CONSTANT.LENGTH.支払先コード}
                    placeholder="傭車先CD"
                  />
                  <TextInput
                    style={{ width: "20rem" }}
                    id="傭車先名"
                    name="傭車先名"
                    value={傭車先名}
                    isReadOnly={props.isReadOnly}
                    setValue={set傭車先名}
                    maxLength={100}
                    placeholder="傭車先名"
                  />
                </li>
              </ul>
            </Col>
            {/* </Row>
          <Row> */}
            <Col className="text-end mb-2">
              <Button
                type="submit"
                onClick={(e) => {
                  e.preventDefault()
                  search()
                }}>
                <FontAwesomeIcon icon={faSearch} />
                検索
              </Button>
            </Col>
          </Row>
        </form>
        <Row>
          <Col style={{ height: "35rem" }}>
            <wjrGrid.FlexGrid
              {...CONSTANT.GRID.PROPERTY_SET.FLEX_GRID_PROPS}
              keyActionTab={wjcGrid.KeyAction.None}
              selectionMode={wjcGrid.SelectionMode.Cell}
              initialized={gridInitialized}
              style={{ height: "30rem" }}>
              <wjrGridFilter.FlexGridFilter />
              <wjrGrid.FlexGridColumn
                header="選択"
                align={"center"}
                binding="荷主品名ID">
                <EmptyTextHeader></EmptyTextHeader>
                <wjrGrid.FlexGridCellTemplate
                  cellType={wjrGrid.CellTemplateType.Cell}
                  template={(
                    context: TWijmoCellTemplateContext<T傭車マスタ>
                  ) => (
                    <Button onClick={() => submitHandler(context.item)}>
                      選択
                    </Button>
                  )}
                />
              </wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                width={120}
                header="傭車先コード"
                binding="傭車先コード"></wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                width={200}
                header="傭車先名"
                binding="傭車先名"></wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                width={80}
                header="車番"
                binding="車番"></wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                width={70}
                header="原動"
                align={"left"}
                binding="原動機有無フラグ">
                <wjrGrid.FlexGridCellTemplate
                  cellType={wjrGrid.CellTemplateType.Cell}
                  template={(context: TWijmoCellTemplateContext<T傭車マスタ>) =>
                    context.item.原動機有無フラグ === 1 ? "有" : ""
                  }
                />
              </wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                width={150}
                header="車種"
                binding="車種区分名称1"></wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                width={150}
                header="乗務員"
                binding="乗務員名"></wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                width={"*"}
                header="備考"
                binding="備考"></wjrGrid.FlexGridColumn>
            </wjrGrid.FlexGrid>
            <GridFooter
              pageSize={pageSize}
              setPageSize={setPageSize}
              gridData={gridData}
              isEnableExport={false}
              flexGrid={flexGrid}></GridFooter>
          </Col>
        </Row>
      </Container>
    </ModalOuter>
  )
}

export default YosyaSearchModal
